"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DCLogo = exports.AskCreate = exports.SaveFavMessage = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _templateObject = _taggedTemplateLiteral(["\n  font-size: 17px;\n  margin-top: 15px;\n  .create-account {\n    text-decoration: underline;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n  }\n"], ["\n  font-size: 17px;\n  margin-top: 15px;\n  .create-account {\n    text-decoration: underline;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  margin: 30px 0 10px 0;\n  .create-account {\n    text-decoration: underline;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n  }\n"], ["\n  margin: 30px 0 10px 0;\n  .create-account {\n    text-decoration: underline;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  margin-right: 20px;\n  img {\n    width: 100px;\n    @media (min-width: 768px) {\n      width: 200px;\n    }\n  }\n"], ["\n  margin-right: 20px;\n  img {\n    width: 100px;\n    @media (min-width: 768px) {\n      width: 200px;\n    }\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require("react-bootstrap/Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _Login = require("./Login");

var _Login2 = _interopRequireDefault(_Login);

var _Register = require("./Register");

var _Register2 = _interopRequireDefault(_Register);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // import axios, { axiosAuth } from "@dreamchimney/react-axios";


var SaveFavMessage = exports.SaveFavMessage = _styledComponents2.default.section(_templateObject);

var AskCreate = exports.AskCreate = _styledComponents2.default.section(_templateObject2);

var DCLogo = exports.DCLogo = _styledComponents2.default.section(_templateObject3);

var LoginModal = function LoginModal(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showLogin = _useState4[0],
      setShowLogin = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showRegister = _useState6[0],
      setShowRegister = _useState6[1];

  var handleSuccessLogin = function handleSuccessLogin(successPayload) {
    setShowModal(false); // send this payload to callback

    console.log("🚀 ~ file: LoginModal.js ~ line 47 ~ handleSuccessLogin ~ successPayload", successPayload);
    props.onLoggedin(successPayload);
  };

  var handleSuccessRegister = function handleSuccessRegister(successPayload) {
    setShowModal(false); // send this payload to callback

    console.log("🚀 ~ file: LoginModal.js ~ line 47 ~ handleSuccessRegister ~ successPayload", successPayload);
    props.onRegister(successPayload);
  };

  var handleCloseLoginModal = function handleCloseLoginModal() {
    setShowModal(false);
    setShowLogin(true);
    setShowRegister(false);
    props.onClose();
  };

  var handleShowRegister = function handleShowRegister() {
    setShowLogin(false);
    setShowRegister(true);
  };

  _react2.default.useEffect(function () {
    setShowModal(props.show);
  }, [props.show]);

  _react2.default.useEffect(function () {
    if (props.register) {
      setShowLogin(false);
      setShowRegister(true);
    }
  }, [props.register]);

  return _react2.default.createElement(_Modal2.default, {
    centered: true,
    size: "lg",
    show: showModal,
    dialogClassName: "modal-login",
    onHide: handleCloseLoginModal,
    backdrop: "static",
    keyboard: true
  }, _react2.default.createElement(_Modal2.default.Header, {
    closeButton: true
  }, props.show_fav ? _react2.default.createElement(SaveFavMessage, null, "Save your favorite tracks and more with a ", _react2.default.createElement("strong", null, "Dream Chimney"), " account.", showLogin && _react2.default.createElement("div", null, "Login below or", " ", _react2.default.createElement("span", {
    className: "create-account",
    onClick: handleShowRegister
  }, "create an account."))) : _react2.default.createElement(_Modal2.default.Title, null, "Dream Chimney: ", showLogin ? "Login" : "Register")), _react2.default.createElement(_Modal2.default.Body, null, showLogin && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement("div", {
    style: {
      display: "flex"
    }
  }, _react2.default.createElement(DCLogo, null, _react2.default.createElement("img", {
    src: "//dreamchimney.com/tracks/img/dc_logo.jpg",
    alt: "Dream Chimney"
  })), _react2.default.createElement(_Login2.default, {
    opened: true,
    onSuccess: handleSuccessLogin
  })), props.show_fav ? null : _react2.default.createElement(AskCreate, null, "New to Dream Chimney?", " ", _react2.default.createElement("span", {
    className: "create-account",
    onClick: handleShowRegister
  }, "Create an account."))), showRegister && _react2.default.createElement("div", null, _react2.default.createElement(_Register2.default, {
    opened: true,
    onSuccess: handleSuccessRegister
  }))));
};

LoginModal.propTypes = {
  onClose: _propTypes2.default.func,
  onLoggedin: _propTypes2.default.func,
  onRegister: _propTypes2.default.func,
  show: _propTypes2.default.bool,
  show_fav: _propTypes2.default.bool
};
LoginModal.defaultProps = {
  show: false,
  show_fav: false
};
exports.default = LoginModal;